import { combineReducers, createReducer } from "@reduxjs/toolkit";

import { IFilterState } from "Model/State/IFilterSate";
import {
  projectsFilterCountSet,
  projectsFilterExpressionSet,
  projectsFilterIdListSet,
  projectsFilterKeySet
} from "Store/Actions";

const idList = createReducer<string[]>([], {
  [projectsFilterIdListSet.type]: (_, { payload: list }) => list
});

const expression = createReducer<string>(``, {
  [projectsFilterExpressionSet.type]: (_, { payload: expr }) => expr
});

const filterKey = createReducer<string>(``, {
  [projectsFilterKeySet.type]: (_, { payload: key }) => key
});

const filterCount = createReducer<[string, number][]>([], {
  [projectsFilterCountSet.type]: (_, { payload: count }) => count
});

export const Filter = combineReducers<IFilterState>({
  idList,
  expression,
  filterKey,
  filterCount
});
